module.exports = __webpack_public_path__ + "img/Penguin-bg-test.1edfe6d1.png";